import { inject } from '@nuxtjs/composition-api';

/**
 * Device State
 * @info ssrRef kullanıldı ama her request'te sıfırlıyoruz. bkz. `/plugins/device.js`
 * @info State/Store yapısı için aşağıdaki gibir bir yapı kullanırsanız herkese aynı state Gider!
 * @info State/Store yapısı için Provide/Inject kullanın.
 */
// const isMobile = ssrRef(true);
// const isTablet = ssrRef(false);
// const isDesktop = ssrRef(false);

/**
 * Device hook
 */
export const useDevice = () => {
  const { isMobile, isTablet, isDesktop, isBot, isInstagram, isIPhone, checkDeviceMode } = inject('devices');
  return {
    isMobile,
    isDesktop,
    isBot,
    isTablet,
    isInstagram,
    isIPhone,
    checkDeviceMode,
  };
};
